<template>
  <div>
    <section class="content-header">
      <h1>{{ $t('post.list') }}</h1>
    </section>

    <section class="content">
      <div class="box box-primary">
        <div class="box-header with-border">
          <router-link :to="{ name: 'PostCreate' }" class="btn btn-primary pull-right">{{ $t('post.add') }}</router-link>
        </div>
        <div class="box-body">
          <item-list-errors entity="post"></item-list-errors>

          <api-table
              entity="Post"
              route="posts"
              path="post"
              :filterable="filterable"
              :sortable="sortable"
              :columns="columns"
          >
          </api-table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import ItemListErrors from '../layout/errors/ItemListErrors'
  import ApiTable from '../ApiTable'

  export default {
    components: {
      ItemListErrors,
      ApiTable,
    },
    data: function () {
      return {
        columns: ['id', 'title', 'summary', 'description', 'actions'],
        filterable: ['id', 'title', 'summary', 'description'],
        sortable: ['id', 'title', 'summary'],
      }
    },
  }
</script>
